import { render, staticRenderFns } from "./RouteDialog.vue?vue&type=template&id=477f920f&scoped=true"
import script from "./RouteDialog.vue?vue&type=script&lang=js"
export * from "./RouteDialog.vue?vue&type=script&lang=js"
import style0 from "./RouteDialog.vue?vue&type=style&index=0&id=477f920f&prod&lang=scss&scoped=true"
import style1 from "./RouteDialog.vue?vue&type=style&index=1&id=477f920f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f920f",
  null
  
)

export default component.exports